
import { useState } from 'react';

export default function InputSelect({
    options,
    value,
    onChange,
    required,
    label,
    name,
    placeholder,
    showPlaceholder = true,
    labelRequire = false,
    colorSelect,
    colorBackgroundInput,
    colorOption
}) {
    /* Handler open select */
    const [isOpen, setIsOpen] = useState(false);
    const handleFocus = () => setIsOpen(true);
    const handleBlur = () => setIsOpen(false);

    const inputSelectContent = (
        <div className={isOpen ? `inputSelect__element inputSelect__element--${colorBackgroundInput} open` : `inputSelect__element inputSelect__element--${colorBackgroundInput}`}>
            <select 
                id={name} 
                name={required ? name + '*' : name} 
                value={value} 
                onChange={onChange} 
                className={`inputSelect__element--textElement inputSelect__element--textElement--${colorSelect}`}
                required={required}
                onFocus={handleFocus}
                onBlur={handleBlur}
            >
                {showPlaceholder && (
                    <option value="">{placeholder}</option>
                )}
                {/* <option value="">Select</option> */}
                {options.map((option) => (
                    <option key={option.value} value={option.value} className={`inputSelect__element--textOption inputSelect__element--textOption--${colorOption}`}>
                        {option.label}
                    </option>
                ))}
            </select>
        </div>
    )
    return (
        <div className="inputSelect">
            {label ? (
                <>
                    <div className={`inputSelect__content__label inputSelect__content__label--${colorBackgroundInput}`}>
                        <div className="inputSelect__content__label">
                            {label && 
                                <label htmlFor={name} className="inputSelect__content__label--textLabel">{required ? label + '*' : label}</label>
                            }
                            {inputSelectContent}
                        </div> 
                    </div>  
                    {required && labelRequire && (
                        <div className="inputSelect__required">
                            <span className="inputSelect__required--textRequired">*Requis</span>
                        </div>
                    )}
                </>
            ) : (
                <>
                    <div className="inputSelect__content">
                        {inputSelectContent}
                    </div>  
                    {required && (
                        <div className="inputSelect__required">
                            <span className="inputSelect__required--textRequired">*Requis</span>
                        </div>
                    )}
                </>
            )} 
        </div>
  )
}
